app.service('productCardSales', function() {

	function setEvents() {
		
	}
	function setElements() {
		
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init : init
	};
});